import { Route, Switch } from "react-router-dom";
import type { FC } from "react";
import { styled } from "@kivra/react-components";
import { ErrorMessage } from "../errors/ErrorMessage";
import { FadeInAndOut } from "../atoms/FadeInAndOut";
import { formRouteArray } from "../../utils/routesConfig";
import type { LegitimateAny } from "@kivra/sdk/types/util/any";

export const FormRouter: FC = () => (
  <div style={{ minWidth: "250px" }}>
    <ErrorMessage />
    <FullForm>
      <FadeInAndOut>
        <Switch>
          {formRouteArray.map(({ path, formComponent }, key) => (
            <Route
              path={path}
              component={formComponent as LegitimateAny}
              key={key}
            />
          ))}
        </Switch>
      </FadeInAndOut>
    </FullForm>
  </div>
);

const FullForm = styled.form({
  width: "100%",
});
